import { render, staticRenderFns } from "./SpaceConfigurationQuotas.vue?vue&type=template&id=1be224f0&"
import script from "./SpaceConfigurationQuotas.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationQuotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports